import { useCallback, useRef } from 'preact/hooks';

import {
  resolveYandexAdsInstance,
  type YaInstance,
} from './lib/resolve-yandex-ads-instance';

export const useYandexInstance = () => {
  const yandexInstanceRef = useRef<YaInstance | undefined>(
    window.Ya && window.yaContextCb
      ? {
          yandex: window.Ya,
          cb: window.yaContextCb,
        }
      : undefined
  );

  const getInstance = useCallback(async () => {
    const { yandex, cb } = yandexInstanceRef.current ?? {};

    if (!yandex || !cb) {
      const instance = await resolveYandexAdsInstance();

      if (!instance?.yandex || !instance?.cb) return undefined;

      yandexInstanceRef.current = { ...instance };

      return instance;
    }

    return yandexInstanceRef.current;
  }, []);

  return getInstance;
};
